import axios from '../services/axios';
import {b64toBlob} from '../helpers/b64toblob';

import {HINTS_URL} from '../config/api';
import {getValidToken, authFormDataHeader, authHeader} from '../services/getValidToken';

export function requestCode(customerId) {
  return axios.get(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/signup/${customerId}/code`);
}

export function verifyCode(customerId, code) {
  return axios.get(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/signin/${customerId}/code/${code}`);
}

export function forgotPassword(email) {
  const data = {
    email,
  };

  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/forgotpassword`, data);
}

export function resetPassword(data) {
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/resetpassword`, data);
}

export async function activateUser(password, signupData) {
  const token = await getValidToken();
  const data = new FormData();
  data.append('password', password);
  data.append('comment', signupData.howDid);
  if (signupData.sign) {
    const blob = b64toBlob(signupData.sign, 'image/jpg');
    data.append('file', blob);
  }
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/customer/activate`, data, authFormDataHeader(token));
}

export function refreshToken(token) {
  return axios.get(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/token/${token}`);
}

export async function changePassword(values) {
  const token = await getValidToken();
  const data = {
    oldPassword: values.currentpassword,
    newPassword: values.password
  };
  return axios.put(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/password`, data, authHeader(token));
}

export async function getProfile() {
  const token = await getValidToken();
  return axios.get(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/profile`, authHeader(token));
}

export async function getMembership() {
  const token = await getValidToken();
  return axios.get(`${HINTS_URL}/HintsService/v1.0/rest/html/membershipagreement`, authHeader(token));
}



// WEBPACK FOOTER //
// ./src/actions/signup-async.js